import { useEffect } from 'react';
import { useLink } from 'react-router-stack';
import { useRouteLocation } from 'react-router-stack';
// to reload page on dashboard

function fantasyRedirect(WrappedComponent: any) {
  return function ChildComponent(props: any) {
    const { state = {} } = useRouteLocation() as any;
    const { gameType = '' } = state;
    const link = useLink();

    useEffect(() => {
      if (!gameType) {
        link.replace('/');
      }
    }, [gameType]);

    //this is to use has a fallback when data is not there as expected
    if (!gameType) {
      return <div />;
    }
    return <WrappedComponent {...props} />;
  };
}

export default fantasyRedirect;
